module.exports = __webpack_public_path__ + "media/stable/components/foundation/base/assets/polygon_badge_hover-b3145dbdf5562061ae5bd02e8169d946.svg";